import {
    Component,
    Input,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { BlockComponent } from "@components/container-block/block.component";
import { LabelComponent } from "@components/label/label.component";
import { SpanComponent } from "@components/span/span.component";
import { ProduktDTO } from "~app/common/models/produkt/ProduktDTO";
import { ProduktspecifikationDTO } from "~app/common/models/produkt/ProduktspecifikationDTO";
import { FormBinderService } from "~app/common/services/form-binder.service";
import { StringFormatPipe } from "../../../../../../common/pipes/string-format.pipe";
import { ProduktDetailTexts } from "../../produkt-detail.texts";
import { MatrisComponent } from "./matris/matris.component";

@Component({
    selector: "rask-produkt-detail-fordelningsmatris",
    templateUrl: "./produkt-detail-fordelningsmatris.component.html",
    styleUrls: ["./produkt-detail-fordelningsmatris.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BlockComponent,
        LabelComponent,
        SpanComponent,
        MatrisComponent,
        StringFormatPipe
    ]
})
export class ProduktDetailFordelningsmatrisComponent implements OnInit {
    form: UntypedFormGroup;
    @Input() produkt: ProduktDTO;
    @Input() produktspecifikation: ProduktspecifikationDTO;
    @Input() rootForm: UntypedFormGroup;
    texts = ProduktDetailTexts.fordelningsmatrisTab.texts;

    private readonly fieldsToUseInForm = ["produktDiameterfordelningar"];
    private readonly formBinder = inject(FormBinderService);

    get displayMatris(): boolean {
        return !!this.produktspecifikation.langdgransMin && !!this.produktspecifikation.langdgransMax && !!this.produktspecifikation.diaToppMin;
    }

    ngOnInit(): void {
        this.createForm();
    }

    private readonly createForm = (): void => {
        this.form = this.formBinder.CreateGroup(this.produktspecifikation, this.fieldsToUseInForm);

        this.rootForm.addControl("produkt-detail-fordelningsmatris", this.form);
        this.form.markAsPristine();
    };
}
